/**
 * lifecycleResourcePriceAdjustment模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const lifecycleResourcePriceAdjustment = {
  // 分页
  page(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourcePriceAdjustment/pagingQuery`, params);
  },
  // 新增
  create(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourcePriceAdjustment/create`, params);
  },
  // 编辑
  update(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourcePriceAdjustment/update`, params);
  },
  // 删除
  delete(id, params) {
    let param = new URLSearchParams()
    param.append(id, params)
    return $http.post(`${global.API_URL}/sme/lifecycleResourcePriceAdjustment/delete`, param);
  }
}

export default lifecycleResourcePriceAdjustment;



// WEBPACK FOOTER //
// ./src/api/lifecycleResourcePriceAdjustment.js